import React, { Fragment } from "react";
import GlobalStyle from "./assets/ui/global-styles";
import { ThemeProvider } from "styled-components";
import theme from "./assets/ui/theme";
import {BrowserRouter as Router, Route} from 'react-router-dom'
import Landing from "./features/Landing";
import WorkWithUs from "./features/WorkWithUs";
import JobDetails from "./features/JobDetails";

class App extends React.Component {

  render() {
    return (
      <ThemeProvider theme={theme}>
          <Router onUpdate={() => window.scrollTo(0, 0)}>
              <Route exact path="/" component={Landing}/>
              <Route exact path="/work-with-us" component={WorkWithUs}/>
              <Route exact path="/work-with-us/:id" component={JobDetails}/>
          </Router>
        <GlobalStyle />
      </ThemeProvider>
    );
  }
}

export default App;
